module.exports = __webpack_public_path__ + "img/digital-marketing-color.d8f115ac.png";